import { Image } from "@outschool/backpack";
import React from "react";

import logo from "../../../images/Outschool_Logo_Color.svg";
import logoWhite from "../../../images/Outschool_Logo_White.svg";

interface HeaderLogoProps {
  isWhiteText?: boolean;
}

export default function HeaderLogo({ isWhiteText }: HeaderLogoProps) {
  return (
    <Image
      // eslint-disable-next-line i18next/no-literal-string
      alt="Outschool"
      sx={{
        width: "206px",
        height: "26px"
      }}
      src={isWhiteText ? logoWhite : logo}
    />
  );
}
